import React, { Component } from 'react';
import Card from 'Utils/Cards/cardGrande';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './FormArea';
import AreaUpdateForm  from './FormArea';
import { iconsh } from "icons";

export default class AreaCrear extends Component {
state = {
    editar: false,
    mensaje: 'Agregar Área',
    password: false,
}
componentWillMount(){
    if(this.props.match.params.id){
        this.props.detail(this.props.match.params.id);
        this.setState({
                editar: true,
                mensaje: 'Editar Área'
            });
    }
}
verPassword = () =>{
    this.setState({
        password: !this.state.password
    })
}
render() {
    const { create, update } = this.props;
    const { updateData, cargando } = this.props;
    return (
    <div className="container m-0 contenido-principal row d-flex justify-content-center">
        <div className="col-md-12">
            <Card
                icono={iconsh.crud_areas}
                titulo={this.state.mensaje}>
                <LoadMask loading={cargando} blur_1>
                    {
                        this.state.editar ?
                            <AreaUpdateForm
                                onSubmit={update}
                                updateData={updateData}
                                editando={true} />
                        :
                            <Form onSubmit={create}  />
                    }
                </LoadMask>
            </Card>
        </div>
    </div>
    )
    }
}
